import { ref, reactive } from 'vue'
import type { Ticket, TicketType, TicketStatus, Priority } from '@/types'

export interface TicketsState {
  tickets: Ticket[]
  selectedTicket: Ticket | null
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    organizationId: string
    projectId: string
    type: TicketType | ''
    status: TicketStatus | ''
    priority: Priority | ''
    assignedTo: string
  }
}

export const getInitialFilters = () => ({
  search: '',
  organizationId: '',
  projectId: '',
  type: '' as TicketType | '',
  status: '' as TicketStatus | '',
  priority: '' as Priority | '',
  assignedTo: '',
})

export const createState = (): TicketsState => {
  const tickets = ref<Ticket[]>([])
  const selectedTicket = ref<Ticket | null>(null)
  const isLoading = ref(false)
  const error = ref<string | null>(null)
  const filters = reactive(getInitialFilters())

  return reactive({
    tickets,
    selectedTicket,
    isLoading,
    error,
    filters,
  }) as unknown as TicketsState
}

export const resetState = (state: TicketsState): void => {
  state.tickets = []
  state.selectedTicket = null
  state.isLoading = false
  state.error = null
  Object.assign(state.filters, getInitialFilters())
}
